import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
//primereact
import { Badge } from "primereact/badge";
//assets
import logo from "../../assets/logo.png";
import darkLogo from "../../assets/darkLogo.png";
//components
import DropdownProfile from "./dropdown/profile.jsx";
import NotificationSchedule from "./NotificationSchedule.jsx";
import DarkModeSwitcher from "../input/DarkModeSwitcher/DarkModeSwitcher.js";
//services
import { getSchedules } from "../../services/GlobalRoles/getSchedules.js";
import { deleteSchedules } from "../../services/GlobalRoles/deleteSchedules.js";
//context
import { AppContext, useAppContext } from "../../context/AppContext.jsx";
import { getIsTrial, getToken, getUserRole } from "../../utils/auth.js";

function Header() {
  const navigate = useNavigate();
  const { permissions } = useAppContext();
  const getDark = localStorage.getItem("appDarkMode");
  const role = getUserRole();
  const location = useLocation();

  const [foto, setFoto] = useState(logo);
  const [darkMode, setDarkMode] = useState(getDark);

  const [isVisible, setIsVisible] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);

  const token = getToken();

  const routes = ["/", "/createAccount", "/403", "/404", "/500", "/success", "/publicMap", "/publicSimulator"];
  const isPublicMapRoute = location.pathname.startsWith("/publicMap");

  const enableSchedules =
    !routes.includes(location.pathname) &&
    !isPublicMapRoute &&
    token &&
    role !== "ibSystem";

  const {
    data: schedules,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["schedules"],
    queryFn: () => {
      getSchedules();
    },
    enabled: !!enableSchedules && !!permissions?.includes("2"),
  });




  const resultCode =
    schedules &&
    schedules
      .filter((schedule) =>
        Array.isArray(schedule.individual) &&
        schedule.individual.every((ind) => ind.status === 3)
      )
      .map((schedule) => schedule.code);


  async function openModal(schedule) {
    // console.log(resultCode)
    setSelectedSchedule(schedule);
    setIsVisible(true);

    if (resultCode?.length > 0) {
      // Criar uma array de promessas de deleção
      const deletePromises = resultCode.map(async (code) => {
        return await deleteSchedules(code);
      });

      // Esperar que todas as promessas sejam resolvidas
      await Promise.all(deletePromises);

      // Fazer o refetch após todas as deletions
      refetch();
    }
  }

  useEffect(() => {
    // Rotas em que o script não deve ser carregado
    const currentPath = '/' + location.pathname.split('/')[1];

    // Função para remover o script existente
    const removeExistingScript = () => {
      const existingScript = document.querySelector(
        'script[data-custom-id="dynamic-chat-widget"]'
      );
      const chatContainer = document.getElementById(
        "anything-llm-embed-chat-container"
      );
      const chatButtonContainer = document.getElementById(
        "anything-llm-embed-chat-button-container"
      );

      if (existingScript) {
        existingScript.remove();
        if (chatContainer) {
          chatContainer.remove();
        }
        if (chatButtonContainer) {
          chatButtonContainer.remove();
        }
      }
    };

    // Verificar se a rota atual está na lista de exclusão
    if (routes.includes(currentPath)) {
      // Remover o script se a rota for proibida
      removeExistingScript();
    } else {
      // Verificar se os dados estão no localStorage
      const userControll = localStorage.getItem("@userControll");
      const userControllID = localStorage.getItem("@userControllID");

      if (userControll && userControllID) {
        removeExistingScript();
        // Criar o script dinamicamente
        const script = document.createElement("script");
        script.setAttribute("data-custom-id", "dynamic-chat-widget"); // Identificador único
        script.setAttribute(
          "data-username",
          `${userControllID} / ${userControll}`
        );
        script.setAttribute(
          "data-embed-id",
          "42c185dc-c36b-4b36-81d8-10973604e8f6"
        );
        script.setAttribute(
          "data-base-api-url",
          "https://ia.walletlote.app.br/api/embed"
        );
        script.setAttribute(
          "data-sponsor-link",
          "https://ibsystem.com/site_ibsystem"
        );
        script.setAttribute("data-sponsor-text", "Desenvolvido por IbSystem");
        script.setAttribute(
          "data-assistant-icon",
          "https://lotemobile.com.br/img/suporte.png"
        );
        script.setAttribute(
          "data-brand-image-url",
          "https://lotemobile.com.br/img/favi.png"
        );
        script.setAttribute("data-assistant-name", "Diogo");
        script.setAttribute(
          "data-greeting",
          "Olá bem vindo! Como posso ajudar?"
        );
        script.setAttribute("data-chat-icon", "chatBubble");
        script.src =
          "https://ia.walletlote.app.br/embed/anythingllm-chat-widget.min.js";

        // Adicionar o script ao body
        document.body.appendChild(script);
      } else {
        // Remover o script se os dados não estiverem no localStorage
        removeExistingScript();
      }
    }
  }, [location]);

  useEffect(() => {
    if (getDark === "true") {
      setFoto(logo);
      setDarkMode(true);
    } else {
      setFoto(darkLogo);
      setDarkMode(false);
    }
  }, [getDark]);

  const isTrial = parseInt(getIsTrial());

  const Trial = () => (
    <div className={`app-trial-header`}>
      <h4 className="py-1 m-0 text-white">
        Seu teste grátis acaba em {isTrial} dias!{" "}
        <a
          className="text-white text-decoration-underline cursor-pointer"
          onClick={() => navigate("/success", { state: { activation: true } })}
        >
          Ativar plano
        </a>{" "}
      </h4>
    </div>
  );

  return (
    <AppContext.Consumer>
      {({
        toggleAppSidebarMobile,
        toggleAppSidebarEnd,
        toggleAppSidebarEndMobile,
        toggleAppTopMenuMobile,
        appHeaderLanguageBar,
        appHeaderMegaMenu,
        appHeaderInverse,
        appSidebarTwo,
        appTopMenu,
        appSidebarNone,
      }) => (
        <>
          <div
            id="header"
            className={
              "app-header " + (appHeaderInverse ? "app-header-inverse" : "")
            }
          >
            <div className="navbar-header">
              {appSidebarTwo && (
                <button
                  type="button"
                  className="navbar-mobile-toggler"
                  onClick={toggleAppSidebarEndMobile}
                >
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
              )}
              <Link className="navbar-brand">
                <img src={foto} alt="logo" />
              </Link>

              {appHeaderMegaMenu && (
                <button
                  type="button"
                  className="navbar-mobile-toggler"
                  data-bs-toggle="collapse"
                  data-bs-target="#top-navbar"
                >
                  <span className="fa-stack fa-lg text-inverse">
                    <i className="far fa-square fa-stack-2x"></i>
                    <i className="fa fa-cog fa-stack-1x"></i>
                  </span>
                </button>
              )}
              {appTopMenu && !appSidebarNone && (
                <button
                  type="button"
                  className="navbar-mobile-toggler"
                  onClick={toggleAppTopMenuMobile}
                >
                  <span className="fa-stack fa-lg text-inverse">
                    <i className="far fa-square fa-stack-2x"></i>
                    <i className="fa fa-cog fa-stack-1x"></i>
                  </span>
                </button>
              )}
              {appSidebarNone && appTopMenu && (
                <button
                  type="button"
                  className="navbar-mobile-toggler"
                  onClick={toggleAppTopMenuMobile}
                >
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
              )}
              {!appSidebarNone && (
                <button
                  type="button"
                  className="navbar-mobile-toggler"
                  onClick={toggleAppSidebarMobile}
                >
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
              )}
            </div>

            <div className="navbar-nav">
              <div>
                <DarkModeSwitcher />
              </div>
              {permissions?.includes("2") && (
                <div className="ms-3 ">
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => openModal(schedules)}
                    className="navbar-link dropdown-toggle d-flex align-items-center"
                  >
                    <i
                      className="pi pi-bell p-overlay-badge"
                      style={{
                        fontSize: "1.5rem",
                        color: darkMode ? "#ffffff" : "#565757",
                      }}
                    >
                      {schedules && schedules.length > 0 && (
                        <Badge
                          style={{ scale: "0.5" }}
                          className="pulse"
                          severity="warning"
                        ></Badge>
                      )}
                    </i>
                  </a>
                </div>
              )}

              <DropdownProfile />

              {appSidebarTwo && (
                <div className="navbar-divider d-none d-md-block"></div>
              )}

              {appSidebarTwo && (
                <div className="navbar-item d-none d-md-block">
                  <Link
                    to="/"
                    onClick={toggleAppSidebarEnd}
                    className="navbar-link icon"
                  >
                    <i className="fa fa-th"></i>
                  </Link>
                </div>
              )}
            </div>

            <NotificationSchedule
              resultCode={resultCode}
              isLoading={isLoading}
              isVisible={isVisible}
              setIsVisible={setIsVisible}
              selectedSchedule={selectedSchedule}
              setSelectedSchedule={setSelectedSchedule}
              refetch={refetch}
            />
          </div>
          {isTrial && isTrial > 0 ? <Trial /> : <></>}
        </>
      )}
    </AppContext.Consumer>
  );
}

export default Header;
